<div class="status-row">
  <div class="status-picker-container">
    <input
      class="status-picker-input"
      placeholder="Enter display status..."
      [formControl]="pickerControl"
      (keydown.enter)="onAdd(pickerControl.value); $event.preventDefault()"
    />
  </div>
  <div class="chips-container inline-chips">
    @for (status of selectedStatuses; track status) {
      <button class="chip" type="button">
        {{ status }}
        <mat-icon
          fontIcon="close"
          class="remove-chip"
          matTooltip="Remove {{ status }}"
          matTooltipShowDelay="500"
          (click)="onRemove(status)"
        ></mat-icon>
      </button>
    }
  </div>
</div>
